/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Camera_Settings_Enabled_HintInputs */

const vi_grower_camera_settings_enabled_hint = /** @type {(inputs: Grower_Camera_Settings_Enabled_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khi tắt, tab Camera ở vùng trồng ngừng gọi camera.`)
};

/**

* @param {Grower_Camera_Settings_Enabled_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_camera_settings_enabled_hint = /** @type {((inputs?: Grower_Camera_Settings_Enabled_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Camera_Settings_Enabled_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_camera_settings_enabled_hint(inputs)
});